export const CHARGEBOARD = {
  CHARGEBOARDLISTS: 'charge_board_lists',
};
